<ocr [RBACORG]="RBACORG" [PERMISSION]="PERMISSION" [ocrEvent]="ocrEvent"></ocr>